import React from "react";

import { Container } from "./styles";

export default function ModalPopup({ message, visible = false, onClick }) {
	const cunstomOnClick = (event) => {
		if (onClick) {
			onClick(event);
		}
	};

	return (
		<Container style={{ display: `${visible ? "block" : "none"}` }}>
			<div className='modal fade'>
				<div className='modal-dialog'>
					<div className='modal-content'>
						<div className='modal-header'>
							<h5 className='modal-title' id='exampleModalLabel'>
								{message.title}
							</h5>
							<button
								type='button'
								className='close'
								onClick={cunstomOnClick}>
								<span aria-hidden='true'>&times;</span>
							</button>
						</div>
						<div className='modal-body'>{message.content}</div>
					</div>
				</div>
			</div>
		</Container>
	);
}
